export const NOTIFICATION_TEMPLATES = '/notification/templates';
export const NOTIFICATION_TEMPLATE = '/notification/template';
export const NOTIFICATION_TEMPLATE_PREVIEW = '/notification/template/preview';
export const NOTIFICATION_SCHEDULES = '/notification/schedules';
